// src/components/admin/products/ProductsAdmin.tsx
// Gerenciamento de Produtos — Shell com 4 abas
// Mesma arquitetura visual do AdminSales

import React, { useState } from 'react';
import { PlusCircle, LayoutTemplate, ShoppingBag, FileText } from 'lucide-react';
import './ProductsAdmin.css';

import CreateProducts from './tabs/CreateProducts';
import LandingProducts from './tabs/LandingProducts';
import MarketplaceProducts from './tabs/MarketplaceProducts';
import ProductDetails from './tabs/ProductDetails';

type ProductTab = 'create' | 'landing' | 'marketplace' | 'details';

interface ProductsAdminProps {
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const TABS: { id: ProductTab; label: string; icon: React.ElementType }[] = [
    { id: 'create', label: 'Criar Produtos', icon: PlusCircle },
    { id: 'landing', label: 'Produtos no Landing', icon: LayoutTemplate },
    { id: 'marketplace', label: 'Produtos no Catálogo', icon: ShoppingBag },
    { id: 'details', label: 'Detalhes do Produto', icon: FileText },
];

const ProductsAdmin: React.FC<ProductsAdminProps> = ({ onShowToast }) => {
    const [activeTab, setActiveTab] = useState<ProductTab>('create');

    return (
        <div className="pa-container adm-page">

            <div className="adm-page-header">
                <h1 className="adm-page-title">Gerenciamento de Produtos</h1>
                <p className="adm-page-subtitle">
                    Crie, configure e publique produtos no marketplace e na landing page
                </p>
            </div>

            <div className="adm-tabs">
                {TABS.map(tab => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            className={`adm-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <Icon size={16} strokeWidth={1.6} />
                            <span>{tab.label}</span>
                        </button>
                    );
                })}
            </div>

            {/* ── CONTEÚDO ── */}
            <div className="pa-content">
                {activeTab === 'create' && <CreateProducts onShowToast={onShowToast} />}
                {activeTab === 'landing' && <LandingProducts onShowToast={onShowToast} />}
                {activeTab === 'marketplace' && <MarketplaceProducts onShowToast={onShowToast} />}
                {activeTab === 'details' && <ProductDetails onShowToast={onShowToast} />}
            </div>

        </div>
    );
};

export default ProductsAdmin;